export enum BIRTH_POSTERS_CATEGORY_IDS {
  'CATEGORY' = 1421,
  'SINGLE_BABY' = 1422,
  'TWIN_BABY' = 1423,
  'TRIPLET_BABY' = 1424,
}
